

export default {
  getChartNombreClientData: state => state.nombre_client,
  getChartNombreGenreClientData: state => state.nombre_genre_client
}